// extracted by mini-css-extract-plugin
export var center = "_5u-2";
export var clickableRow = "_5u-5";
export var expandedRow = "_5u-7";
export var hoverable = "_5u-4";
export var left = "_5u-1";
export var right = "_5u-3";
export var row = "_5u-0";
export var selectedRow = "_5u-6";
export var summaryRow = "_5u-8";